import { Component, ViewEncapsulation, Renderer2, ViewChild, ElementRef, OnDestroy, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ItemsService } from '../../../../services/items.service';
import { FormBuilder, FormControl, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import Swal from 'sweetalert2';
import { HomeService } from '../../../../services/home.service';
import { Stockitem } from '../../../../interfaces/stockitem';
import { users } from '../../../../interfaces/users';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { SelectedProductDetail } from '../../../../interfaces/addorder';
import { UserService } from '../../../../services/user';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { OrdersService } from '../../../../services/orders';
import { GovernoratesService } from '../../../../services/governorates.service';
import { PetServices } from '../../../../services/petservices';
import { WarehouseTypeService } from '../../../../services/warehouse-type';
import { PointOfSaleService } from '../../../../services/pos';
import { ClientsService } from '../../../../services/clients.service';
import { Subject, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, filter, switchMap, takeUntil, tap } from 'rxjs/operators';

export interface SelectedServiceDetail {
  service: any;
  quantity: number;
  price: number;
}
// Internal type aliases for readability (no runtime impact)
type StockItem = Stockitem;
type UserData = any;

@Component({
  selector: 'app-addorderstore',
  templateUrl: './addorderstore.component.html',
  styleUrl: './addorderstore.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class AddorderstoreComponent implements OnDestroy {
  private destroy$ = new Subject<void>();
  // ===============================
  // UI State & Flags
  // ===============================
  contentReady = false;
  isMobile = false;
  isAr = false;
  isUpdate = false;
  inUpdatePage = false;
  submitted = false;
  displaybutton = false;
  clearClientBtn = false;
  clientLookupLoading = false;
  clientLookupMessage = '';
  clearcart = false;
  showAllUsers = false;
  showCreateByUserField = false;
  warehouseIsStore = false;
  editPriceEnabled = true;
  hasDelivery = false;
  hasToken = false;
  hasQrOffer = false;
  classToggled = false;
  selectedValueFromStock = true;
  cartHasProducts = false;
  cartHasServices = false;
  cartItems: any[] = [];
  servicesList: any[] = [];
  filteredServices: any[] = [];
  selectedServicesDetails: SelectedServiceDetail[] = [];
  serviceSearchValue = '';
  // ===============================
  // Form & Data Models
  // ===============================
  data!: FormGroup;
  dataForm!: FormData;


  // Client Information
  client_name = '';
  phone_number = '';
  another_phone = '';
  address = '';
  building_number = '';
  street = '';
  landmark = '';
  floor = '';
  home = '';

  // Order Details
  delivery_fees = '';
  note = '';
  total = 0;
  income = 0;
  due: any = '';
  totalOriginalPrice = 0;
  totalUserEnteredPrice = 0;
  originalPrice = 0;
  bonus = 0;

  // Selection & Filtering
  selectedProduct: StockItem | null = null;
  selectedProductFromStock = '';
  selectedProductsDetails: SelectedProductDetail[] = [];
  productname: StockItem[] = [];
  productnamefixed: StockItem[] = [];
  filteredProviders: StockItem[] = [];
  users: UserData[] = [];
  governorates: any[] = [];
  cities: any[] = [];

  // Arrays for Order Submission
  arrayofitems: any[] = [];
  arrayofOlditems: any[] = [];
  arrayofqty: (number | null)[] = [];
  arrayofprices: (number | null)[] = [];
  arrayofids: (number | null)[] = [];
  arrayofbounes: number[] = [];
  arrayofTypes: ('product' | 'service')[] = [];

  // Location & Warehouse
  government_id: any = '';
  city_id: any = '';
  warehouseId: string | null = null;
  countryId!: number;
  selectedCountry: string | null = null;

  // User & Account
  userId = '';
  thisUserId: any = null;
  accounttype: string | null = null;
  createOrderByid: any = null;
  createOrderByidType: any = null;

  // Product Selection State
  productnameselectedvalu = 'select product';
  selectedProductLength = 0;
  productindex = 0;
  productqtyindex = 0;
  productpriceindex = 0;
  searchValue = '';
  // Update Context
  updateId: any = null;

  // ===============================
  // View Children
  // ===============================
  @ViewChild('productSelect', { static: false }) productSelect!: ElementRef;
  @ViewChild('mySelect') mySelect!: MatSelect;
  @ViewChild('productInput', { read: MatAutocompleteTrigger }) productAutocompleteTrigger?: MatAutocompleteTrigger;
  @ViewChild('serviceInput', { read: MatAutocompleteTrigger }) serviceAutocompleteTrigger?: MatAutocompleteTrigger;
  @ViewChild('productSelectWrap') productSelectWrap?: ElementRef<HTMLElement>;
  @ViewChild('serviceSelectWrap') serviceSelectWrap?: ElementRef<HTMLElement>;

  @HostListener('document:pointerdown', ['$event'])
  closeAutocompleteOnOutsideClick(event: PointerEvent): void {
    const target = event.target as HTMLElement | null;
    if (!target) return;

    if (target.closest('.mat-mdc-autocomplete-panel, .bb-chip-autocomplete-panel')) {
      return;
    }

    if (
      this.productAutocompleteTrigger?.panelOpen &&
      !this.productSelectWrap?.nativeElement.contains(target)
    ) {
      this.productAutocompleteTrigger.closePanel();
    }

    if (
      this.serviceAutocompleteTrigger?.panelOpen &&
      !this.serviceSelectWrap?.nativeElement.contains(target)
    ) {
      this.serviceAutocompleteTrigger.closePanel();
    }
  }

  // ===============================
  // Constructor
  // ===============================
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private _homeService: HomeService,
    private _orderService: OrdersService,
    private _userService: UserService,
    private governoratesService: GovernoratesService,
    private deviceService: DeviceDetectorService,
    private petServices: PetServices,
    public warehouseTypeService: WarehouseTypeService,
    private posService: PointOfSaleService,
    private clientsService: ClientsService
  ) { }

  // ===============================
  // Lifecycle
  // ===============================
  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();
    this.isAr = localStorage.getItem('language') === 'ar';
    this.hasToken = !!localStorage.getItem('token');
    this.warehouseId = localStorage.getItem('posId');
    this.accounttype = String(this.checkAccountType());

    this.initiate();
    this.listenToAddressChanges();
    this.watchClientPhone();

    this.loadWarehouseType();
    this.loadBusinessSettings();
    this.loadGovernorates();
    this.getUserId();
    this.displaybutton = this.arrayofitems.length !== 0;
    this.getAllStockData();
    this.getAllServicesData();
    this.getAllUsers();
    this.restoreCartFromStorage();
    this.restoreClientFromStorage();
    this.handleQueryParamCart();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  onSearchChange(event: Event): void {

    const input = event.target as HTMLInputElement;

    this.searchValue = input.value;

    const search = input.value.toLowerCase();

    this.filteredProviders = this.productname.filter(p =>
      this.getProductSearchText(p).includes(search)
    );

  }

  getProductDisplayName(product: any): string {
    return this.pickLocalizedName(product, 'name_ar', 'name_en');
  }

  getServiceDisplayName(service: any): string {
    return this.pickLocalizedName(service, 'name_ar', 'name_en');
  }

  private pickLocalizedName(item: any, arKey: string, enKey: string): string {
    const primary = this.isAr ? item?.[arKey] : item?.[enKey];
    const fallback = this.isAr ? item?.[enKey] : item?.[arKey];

    return String(primary || fallback || item?.name || '');
  }

  private getProductSearchText(product: any): string {
    return [product?.name_ar, product?.name_en, product?.name]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
  }

  private getServiceSearchText(service: any): string {
    return [service?.name_ar, service?.name_en, service?.name]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
  }
  get hasAtLeastOneItem(): boolean {
    return this.selectedProductsDetails.length > 0 || this.selectedServicesDetails.length > 0;
  }

  get canSelectProducts(): boolean {
    return this.selectedValueFromStock;
  }

  get canSelectServices(): boolean {
    return this.selectedValueFromStock;
  }

  getAllServicesData(): void {
    if (!this.warehouseId) return;

    this.petServices.getByWarehouse(Number(this.warehouseId), 1, 1000).subscribe({
      next: (res) => {
        const services = res?.data || res?.services || [];
        this.servicesList = services.sort((a: any, b: any) =>
          this.getServiceDisplayName(a).localeCompare(this.getServiceDisplayName(b), this.isAr ? 'ar' : 'en', { sensitivity: 'base' })
        );
        this.filteredServices = [...this.servicesList];
      },
      error: (error) => {
        console.error('Failed to load services:', error);
      }
    });
  }
  onServiceSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.serviceSearchValue = input.value;

    const search = input.value.toLowerCase().trim();

    this.filteredServices = this.servicesList.filter((s: any) =>
      this.getServiceSearchText(s).includes(search)
    );
  }
  addService(event: any): void {
    const service = event.option.value;

    const exists = this.selectedServicesDetails.find(
      x => x.service.id === service.id
    );

    if (!exists) {
      this.selectedServicesDetails.push({
        service,
        quantity: 1,
        price: Number(service.pricea || 0)
      });
    }

    this.serviceSearchValue = '';
  }
  removeService(id: number): void {
    this.selectedServicesDetails =
      this.selectedServicesDetails.filter(s => s.service.id !== id);
    if (this.selectedServicesDetails.length === 0) {
      this.cartHasServices = false;
    }
  }
  trackByService(index: number, item: any) {
    return item.service.id;
  }
  addProduct(event: any): void {

    const product = event.option.value;

    const exists = this.selectedProductsDetails.find(
      x => x.product.id === product.id
    );

    if (!exists) {

      this.selectedProductsDetails.push({
        product,
        quantity: 1,
        price: this.getProductPriceByAccountType(product),
        bounes: null
      });

    }

    this.searchValue = '';

  }
  removeProduct(id: number): void {

    this.selectedProductsDetails =
      this.selectedProductsDetails.filter(
        p => p.product.id !== id
      );
    if (this.selectedProductsDetails.length === 0) {
      this.cartHasProducts = false;
    }

  }
  trackByProduct(index: number, item: any) {
    return item.product.id;
  }
  // ===============================
  // Price Calculation Helpers (Extracted)
  // ===============================
  private getProductPriceByAccountType(product: StockItem): number {
    return Number(product.pricea ?? 0);
  }

  // ===============================
  // Form Initialization
  // ===============================
  private initiate(): void {
    this.data = this.fb.group({
      client_name: ['', Validators.required],
      phone_number: ['', [Validators.required, this.englishDigitsOnlyValidator, this.egyptOrKsaPhoneValidator]],
      another_phone: ['', [this.englishDigitsOnlyValidator, Validators.pattern('^[0-9]+$')]],

      building_number: [''],
      street: [''],
      landmark: [''],
      floor: [''],
      home: [''],
      address: [''],

      city_id: [''],
      government_id: [''],
      delivery_fees: [''],

      quantity: [''],
      item: [''],
      createby: [''],
      price: [''],
      bounes: [''],
      note: [''],
      arrayofids: ['']
    });

    this.updateDeliveryValidators();
  }

  private updateDeliveryValidators(): void {
    if (!this.data) return;

    const deliveryRequiredControls = [
      'another_phone',
      'building_number',
      'street',
      'landmark',
      'floor',
      'home',
      'address',
      'government_id',
      'city_id',
      'delivery_fees'
    ];

    deliveryRequiredControls.forEach((controlName) => {
      const control = this.data.get(controlName);
      if (!control) return;

      if (this.hasDelivery) {
        if (controlName === 'another_phone') {
          control.setValidators([
            Validators.required,
            this.englishDigitsOnlyValidator,
            Validators.pattern('^[0-9]+$'),
            this.egyptOrKsaPhoneValidator
          ]);
        } else {
          control.setValidators([Validators.required]);
        }
      } else {
        if (controlName === 'another_phone') {
          control.setValidators([
            this.englishDigitsOnlyValidator,
            Validators.pattern('^[0-9]+$')
          ]);
        } else {
          control.clearValidators();
        }
      }

      control.updateValueAndValidity({ emitEvent: false });
    });
  }

  private buildAddressFromParts(values: any): string {
    const parts = [
      values.building_number ? `مبنى ${values.building_number}` : '',
      values.street ? `شارع ${values.street}` : '',
      values.landmark ? `علامة مميزة: ${values.landmark}` : '',
      values.floor ? `الدور ${values.floor}` : '',
      values.home ? `شقة ${values.home}` : '',
    ].filter(Boolean);

    return parts.join(' - ');
  }

  private listenToAddressChanges(): void {
    this.data.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((values) => {
        if (!this.hasDelivery) return;

        const fullAddress = this.buildAddressFromParts(values);
        this.address = fullAddress;
        this.data.patchValue({ address: fullAddress }, { emitEvent: false });
      });
  }

  // ===============================
  // Validator (Fixed Binding)
  // ===============================
  englishDigitsOnlyValidator = (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    const arabicRegex = /[\u0600-\u06FF\u0660-\u0669\u06F0-\u06F9]/;
    return arabicRegex.test(control.value)
      ? { arabicNotAllowed: true }
      : null;
  };

  egyptOrKsaPhoneValidator = (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;

    const phone = String(control.value).trim();
    const egyptMobileRegex = /^(01[0125]\d{8}|\+201[0125]\d{8}|00201[0125]\d{8})$/;
    const ksaMobileRegex = /^(05\d{8}|\+9665\d{8}|009665\d{8})$/;

    return egyptMobileRegex.test(phone) || ksaMobileRegex.test(phone)
      ? null
      : { invalidEgyptOrKsaPhone: true };
  };

  shouldShowError(controlName: string): boolean {
    const control = this.data?.get(controlName);
    return !!control && control.invalid && (control.touched || this.submitted);
  }

  private watchClientPhone(): void {
    this.data
      .get('phone_number')
      ?.valueChanges.pipe(
        debounceTime(450),
        distinctUntilChanged(),
        tap(() => {
          this.clientLookupMessage = '';
        }),
        filter((value) => this.normalizePhone(value).length >= 8),
        tap(() => {
          this.clientLookupLoading = true;
        }),
        switchMap((value) =>
          this.clientsService
            .searchClients(String(value).trim(), Number(this.warehouseId) || undefined)
            .pipe(
              catchError((error) => {
                console.error('Failed to search client by phone:', error);
                return of(null);
              })
            )
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((response) => {
        this.clientLookupLoading = false;
        const client = this.findMatchedClient(response, this.phone_number);

        if (!client) return;

        this.applyExistingClient(client);
      });
  }

  private findMatchedClient(response: any, phone: string): any | null {
    const clients = this.extractClients(response);
    const normalizedPhone = this.normalizePhone(phone);

    if (!normalizedPhone) return null;

    return (
      clients.find((client) =>
        [
          client?.phone_number,
          client?.phone,
          client?.another_phone,
          client?.mobile,
        ].some((clientPhone) => this.normalizePhone(clientPhone) === normalizedPhone)
      ) || null
    );
  }

  private extractClients(response: any): any[] {
    if (Array.isArray(response)) return response;
    if (Array.isArray(response?.clients)) return response.clients;
    if (Array.isArray(response?.data)) return response.data;
    if (Array.isArray(response?.clients?.data)) return response.clients.data;
    if (Array.isArray(response?.data?.clients)) return response.data.clients;
    if (Array.isArray(response?.data?.data)) return response.data.data;

    return [];
  }

  private applyExistingClient(client: any): void {
    this.client_name =
      client?.client_name ||
      client?.name ||
      client?.user?.name ||
      this.client_name;
    this.phone_number =
      client?.phone_number ||
      client?.phone ||
      this.phone_number;
    this.another_phone = client?.another_phone || client?.alternative_phone || this.another_phone || '';
    this.address = client?.address || this.address || '';
    this.building_number = client?.building_number || this.building_number || '';
    this.street = client?.street || this.street || '';
    this.landmark = client?.landmark || this.landmark || '';
    this.floor = client?.floor || this.floor || '';
    this.home = client?.home || client?.apartment || this.home || '';
    this.government_id = client?.government_id || client?.grov_id || this.government_id || '';
    this.city_id = client?.city_id || this.city_id || '';
    this.clientLookupMessage = this.isAr
      ? 'تم تحميل بيانات العميل تلقائيًا'
      : 'Client data loaded automatically';

    this.data.patchValue(
      {
        client_name: this.client_name,
        phone_number: this.phone_number,
        another_phone: this.another_phone,
        building_number: this.building_number,
        street: this.street,
        landmark: this.landmark,
        floor: this.floor,
        home: this.home,
        address: this.address,
        government_id: this.government_id,
        city_id: this.city_id,
      },
      { emitEvent: false }
    );
  }

  private normalizePhone(value: any): string {
    let phone = String(value ?? '').replace(/\D/g, '');

    if (phone.startsWith('0020')) phone = `0${phone.slice(4)}`;
    if (phone.startsWith('20') && phone.length === 12) phone = `0${phone.slice(2)}`;
    if (phone.startsWith('00966')) phone = `0${phone.slice(5)}`;
    if (phone.startsWith('966') && phone.length === 12) phone = `0${phone.slice(3)}`;

    return phone;
  }

  hasNoSelectedItems(): boolean {
    return this.selectedProductsDetails.length === 0 && this.selectedServicesDetails.length === 0;
  }

  shouldShowItemsError(): boolean {
    return this.submitted && this.hasNoSelectedItems();
  }

  getErrorMessage(controlName: string, label: string): string {
    const control = this.data?.get(controlName);

    if (!control || !control.errors) {
      return '';
    }

    if (control.errors['required']) {
      return this.isAr ? `${label} مطلوب` : `${label} is required`;
    }

    if (control.errors['invalidEgyptOrKsaPhone']) {
      return this.isAr
        ? `${label} لازم يكون رقم موبايل مصري أو سعودي صحيح`
        : `${label} must be a valid Egyptian or Saudi mobile number`;
    }

    if (control.errors['arabicNotAllowed']) {
      return this.isAr
        ? `${label} لازم يكون بأرقام انجليزية بدون حروف عربية`
        : `${label} must use English digits without Arabic characters`;
    }

    if (control.errors['pattern']) {
      return this.isAr ? `${label} لازم يكون أرقام فقط` : `${label} must contain digits only`;
    }

    return this.isAr ? `${label} غير صحيح` : `${label} is invalid`;
  }

  getMissingRequiredCount(): number {
    if (!this.data) {
      return 0;
    }

    return Object.keys(this.data.controls).filter((controlName) => {
      const control = this.data.get(controlName);
      return control?.hasError('required');
    }).length + (this.hasNoSelectedItems() ? 1 : 0);
  }

  private validateBeforeSubmit(): boolean {
    this.submitted = true;

    if (this.data.invalid || this.hasNoSelectedItems()) {
      this.data.markAllAsTouched();

      Swal.fire({
        icon: 'warning',
        title: this.isAr ? 'تأكد من بيانات الاوردر' : 'Please check order data',
        text: this.isAr
          ? 'راجع الرسائل تحت الحقول المطلوبة أو غير الصحيحة'
          : 'Review the messages below the required or invalid fields',
        confirmButtonText: this.isAr ? 'تمام' : 'OK',
      });

      return false;
    }

    return true;
  }

  // ===============================
  // Data Loading Methods
  // ===============================
  getAllStockData(): void {
    const posId = localStorage.getItem('posId');
    if (!posId) return;
    this._orderService.getStocksData(posId).subscribe({
      next: (data) => {
        this.productname = data.stocks
          .filter((item: StockItem) => Number(item.quantity) > 0)
          .sort((a: StockItem, b: StockItem) =>
            this.getProductDisplayName(a).localeCompare(this.getProductDisplayName(b), this.isAr ? 'ar' : 'en', { sensitivity: 'base' })
          );
        this.filteredProviders = [...this.productname];
        if (this.inUpdatePage) {
          this.buildSelectedProductsFromParams();
        }
      },
      error: (error) => console.error('Failed to load stock data:', error),
    });
  }

  getAllUsers(): void {
    this.contentReady = true;
    this._homeService.getAllUsers().subscribe({
      next: (data) => {
        this.users = this.filterUsersByType(data.reverse());
        this.contentReady = false;
      },
      error: (error) => console.error('Failed to load users:', error),
    });
  }

  loadGovernorates(): void {
    this.contentReady = true;
    this.governoratesService.getAllGovernorates().subscribe({
      next: (data) => {
        this.governorates = data;
        this.contentReady = false;
      },
      error: (err) => console.error('Failed to load governorates:', err),
    });
  }

  loadCities(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const governorateId = Number(selectElement.value);
    if (!governorateId) {
      this.cities = [];
      return;
    }
    this.governoratesService.getCity(governorateId).subscribe({
      next: (res) => {
        this.cities = res;
        this.contentReady = false;
      },
      error: (err) => {
        console.error('Error loading cities', err);
        this.cities = [];
      }
    });
  }

  loadWarehouseType(): void {
    if (!this.warehouseId) return;
    this._userService.getWarehouseType(Number(this.warehouseId)).subscribe({
      next: (data) => {
        this.warehouseIsStore = data['warehouses_type'] === '1';
      }
    });
  }

  loadBusinessSettings(): void {
    if (!this.warehouseId) return;

    this.posService.getBusinessSettings(this.warehouseId).subscribe({
      next: (res) => {
        const settings = res?.settings ?? res?.business_setting ?? res;
        this.editPriceEnabled = this.toBoolean(settings?.edit_price, true);
        this.hasDelivery = this.toBoolean(settings?.has_delivery, false);
        this.updateDeliveryValidators();
      },
      error: () => {
        this.editPriceEnabled = true;
        this.hasDelivery = false;
        this.updateDeliveryValidators();
      }
    });
  }

  private toBoolean(value: any, fallback: boolean): boolean {
    if (value === null || value === undefined || value === '') {
      return fallback;
    }

    return value === true || value === 'true' || value === 1 || value === '1';
  }

  // ===============================
  // User & Account Methods
  // ===============================
  getUserId(): void {
    this._userService.getUserId().subscribe({
      next: (data) => {
        this.thisUserId = data['user_id'];
      },
      error: (error) => console.error('Failed to get user ID:', error),
    });
  }

  checkAccountType(): string {
    this._userService.getAccountType().subscribe({
      next: (data) => {
        this.accounttype = data['user_type'];
        if (this.accounttype === '1' || this.accounttype === '6') {
          this.showAllUsers = true;
        }
      },
      error: (error) => console.error('Failed to get account type:', error),
    });
    return this.accounttype ?? '';
  }

  filterUsersByType(users: users[], typeToMatch: string = this.thisUserId): users[] {
    return users.filter(user => user.id !== typeToMatch);
  }

  // ===============================
  // Product Selection Handlers
  // ===============================

  openSelect(): void {
    this.mySelect?.open();
  }

  // ===============================
  // Cart & Client Restoration
  // ===============================
  private restoreCartFromStorage(): void {
    const storedCart = localStorage.getItem('cart');
    if (storedCart && storedCart !== '[]') {
      try {
        const cartItems = JSON.parse(storedCart);
        this.applyCartItems(cartItems);
      } catch (error) {
        console.error('Invalid stored cart data:', error);
        localStorage.removeItem('cart');
        localStorage.removeItem('cartWarehouseId');
      }

    }
  }

  private restoreClientFromStorage(): void {
    const storedClient = localStorage.getItem('clientinfo');
    if (storedClient) {
      this.clearClientBtn = true;
      const client = JSON.parse(storedClient);
      this.client_name = client['client_name'] ?? '';
      this.phone_number = client['phone_number'] ?? '';
      this.another_phone = client['another_phone'] ?? '';
      this.address = client['address'] ?? '';

      this.building_number = client['building_number'] ?? '';
      this.street = client['street'] ?? '';
      this.landmark = client['landmark'] ?? '';
      this.floor = client['floor'] ?? '';
      this.home = client['home'] ?? '';
      this.government_id = client['government_id'] ?? client['grov_id'] ?? '';
      this.city_id = client['city_id'] ?? '';

      this.data.patchValue(
        {
          client_name: this.client_name,
          phone_number: this.phone_number,
          another_phone: this.another_phone,
          building_number: this.building_number,
          street: this.street,
          landmark: this.landmark,
          floor: this.floor,
          home: this.home,
          address: this.address,
          government_id: this.government_id,
          city_id: this.city_id,
        },
        { emitEvent: false }
      );
    }
  }

  private handleQueryParamCart(): void {
    this.route.queryParams.subscribe(params => {
      const cartParam = params['cart'];
      if (cartParam) {
        try {
          const cartItems = JSON.parse(cartParam);
          this.warehouseId = params['warehouseIdFromCart'] ?? this.warehouseId;
          this.loadBusinessSettings();
          console.log('Received cart from query params:', this.warehouseId);
          this.applyCartItems(cartItems);

        } catch (error) {
          console.error('Invalid cart data:', error);
        }
      }
    });
  }

  private applyCartItems(cartItems: any[]): void {
    this.cartItems = Array.isArray(cartItems) ? cartItems : [];
    this.clearcart = this.cartItems.length > 0;
    this.selectedValueFromStock = true;

    const productItems = this.cartItems.filter(item => this.getCartItemType(item) === 'product');
    const serviceItems = this.cartItems.filter(item => this.getCartItemType(item) === 'service');

    this.cartHasProducts = productItems.length > 0;
    this.cartHasServices = serviceItems.length > 0;

    this.selectedProductsDetails = productItems.map((item: StockItem) => ({
      product: item,
      quantity: 1,
      price: this.getProductPriceByAccountType(item),
      bounes: null
    }));

    this.selectedServicesDetails = serviceItems.map((service: any) => ({
      service,
      quantity: 1,
      price: Number(service.pricea || service.price || 0)
    }));
  }

  private getCartItemType(item: any): 'product' | 'service' {
    if (item?.cartItemType === 'service') {
      return 'service';
    }

    if (!item?.cartItemType && item?.quantity === undefined) {
      return 'service';
    }

    return 'product';
  }

  // ===============================
  // Order Submission Logic
  // ===============================
  submitSelectedProducts(): void {
    this.arrayofitems = [];
    this.arrayofids = [];
    this.arrayofprices = [];
    this.arrayofqty = [];
    this.arrayofOlditems = [];
    this.arrayofbounes = [];
    this.arrayofTypes = [];
    this.totalOriginalPrice = 0;
    this.totalUserEnteredPrice = 0;

    // =========================
    // Products
    // =========================
    for (const item of this.selectedProductsDetails) {
      const product = item.product;
      const quantity = Number(item.quantity ?? 0);
      const enteredPrice = Number(item.price ?? 0);
      const bounes = Number(item.bounes ?? 0);

      this.originalPrice = this.getProductPriceByAccountType(product);

      this.arrayofOlditems.push(this.originalPrice);
      this.arrayofitems.push(this.getProductDisplayName(product));
      this.arrayofids.push(product.id);
      this.arrayofprices.push(enteredPrice);
      this.arrayofqty.push(quantity);
      this.arrayofbounes.push(bounes);
      this.arrayofTypes.push('product');

      this.totalOriginalPrice += this.originalPrice * quantity;
      this.totalUserEnteredPrice += enteredPrice * quantity;
    }

    // =========================
    // Services
    // =========================
    for (const item of this.selectedServicesDetails) {
      const service = item.service;
      const quantity = Number(item.quantity ?? 1);
      const price = Number(item.price ?? 0);

      // لو backend بيفرق بين product و service
      this.arrayofitems.push(this.getServiceDisplayName(service));
      this.arrayofids.push(service.id);
      this.arrayofprices.push(price);
      this.arrayofqty.push(quantity);
      this.arrayofOlditems.push(price); // الخدمة سعرها الأصلي = السعر الحالي غالبًا
      this.arrayofbounes.push(0);
      this.arrayofTypes.push('service');

      this.totalOriginalPrice += price * quantity;
      this.totalUserEnteredPrice += price * quantity;
    }

    this.income = this.totalOriginalPrice;

    if (this.accounttype === '2') {
      this.due = Math.round(this.totalUserEnteredPrice) - Math.round(this.totalOriginalPrice);
    } else {
      if (this.createOrderByid != null && this.createOrderByidType === '2') {
        this.due = Math.round(this.totalUserEnteredPrice) - Math.round(this.totalOriginalPrice);
      } else {
        this.due = '';
      }
    }

    this.total = this.totalUserEnteredPrice;
  }

  private appendPostData(): void {
    this.total = Number(this.total) || 0;

    const values = this.data.value;
    const deliveryFees = this.hasDelivery ? Number(values.delivery_fees || 0) : 0;
    const orderAddress = this.hasDelivery ? (values.address || this.address || '') : 'الفرع';
    const grovId = this.hasDelivery ? String(values.government_id || '') : '2';
    const cityId = this.hasDelivery ? String(values.city_id || '') : '75';
    const anotherPhone = this.hasDelivery ? String(values.another_phone || '') : this.another_phone;

    this.dataForm = new FormData();
    this.dataForm.append('client_name', this.client_name);
    this.dataForm.append('phone_number', this.phone_number);
    this.dataForm.append('another_phone', anotherPhone);
    this.dataForm.append('total', String(this.total + deliveryFees));
    this.dataForm.append('income', String(this.income));
    this.dataForm.append('address', orderAddress);
    this.dataForm.append('grov_id', grovId);
    this.dataForm.append('city_id', cityId);
    this.dataForm.append('note', this.note || '');
    this.dataForm.append('delivery_fees', String(deliveryFees));

    for (let i = 0; i < this.arrayofitems.length; i++) {

      this.dataForm.append('item[]', this.arrayofitems[i]);

      this.dataForm.append(
        'quantity[]',
        String(this.arrayofqty[i] ?? 1)
      );

      this.dataForm.append(
        'price[]',
        String(this.arrayofprices[i] ?? 0)
      );

      this.dataForm.append(
        'itemsprices[]',
        String(this.arrayofOlditems[i] ?? 0)
      );

      this.dataForm.append(
        'product_id[]',
        String(this.arrayofids[i] ?? 0)
      );

      this.dataForm.append(
        'item_type[]',
        this.arrayofTypes[i] ?? 'product'
      );

      if (this.warehouseIsStore) {
        this.dataForm.append(
          'bonuses[]',
          String(this.arrayofbounes[i] ?? 0)
        );
      }
    }
    this.dataForm.append('order_status', '1');
    this.dataForm.append('user_id', this.createOrderByid ?? this.thisUserId);
    this.dataForm.append('due', String(this.due));
    this.dataForm.append('duenow', String(this.due));
    this.dataForm.append('warehouse_id', String(this.warehouseId));

  }

  // ===============================
  // Action Methods
  // ===============================
  onSubmit(): void {
    if (!this.validateBeforeSubmit()) {
      return;
    }

    this.contentReady = true;
    this.submitSelectedProducts();
    this.appendPostData();
    this._orderService.addOrder(this.dataForm).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? 'اوردرك قيد الانتظار' : 'Order Placed',
          showConfirmButton: false,
          timer: 1500,
        });
        this.contentReady = false;
        localStorage.removeItem('cart');
        localStorage.removeItem('cartWarehouseId');
        localStorage.removeItem('clientinfo');
        if (this.hasQrOffer) {
          this.generateQr(res['order'].id, res['client'].id, this.thisUserId);
        }
        this.router.navigateByUrl(this.isMobile ? '/orders.mobile' : '/Orders');
      },
      error: (err) => {

        let backendError = err?.error?.error || err?.error?.message || '';

        let message = backendError;

        if (backendError.includes('Not enough stock')) {

          const productId = backendError.match(/\d+/)?.[0];

          message = this.isAr
            ? `لا يوجد مخزون كافي للمنتج رقم ${productId}`
            : `Not enough stock for product ID ${productId}`;

        }

        Swal.fire({
          icon: 'error',
          title: message || (this.isAr ? 'فشل حفظ الاوردر' : 'Order Failed'),
          confirmButtonText: this.isAr ? 'تمام' : 'OK'
        });

        this.contentReady = false;
      },
    });
  }

  updateOrder(): void {
    if (!this.validateBeforeSubmit()) {
      return;
    }

    this.contentReady = true;
    this.submitSelectedProducts();
    this.appendPostData();
    this._orderService.updateOrder(this.updateId, this.dataForm).subscribe({
      next: () => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? 'اوردرك قيد الانتظار' : 'Order Placed',
          showConfirmButton: false,
          timer: 1500,
        });
        this.contentReady = false;
        localStorage.removeItem('cart');
        localStorage.removeItem('cartWarehouseId');
        localStorage.removeItem('clientinfo');
        this.router.navigateByUrl(this.isMobile ? '/orders.mobile' : '/Orders');
      },
      error: () => {
        Swal.fire({
          icon: 'error',
          title: this.isAr ? 'فشل حفط الاوردر' : 'Order Failed',
          confirmButtonText: this.isAr ? 'تمام' : 'ok',
        });
        this.contentReady = false;
      },
    });
  }

  clearClient(): void {
    localStorage.removeItem('clientinfo');
    this.clearClientBtn = false;
    this.client_name = '';
    this.phone_number = '';
    this.another_phone = '';
    this.address = '';
    this.building_number = '';
    this.street = '';
    this.landmark = '';
    this.floor = '';
    this.home = '';
    this.delivery_fees = '';
    this.government_id = '';
    this.city_id = '';
    this.clientLookupLoading = false;
    this.clientLookupMessage = '';
    this.data.patchValue(
      {
        client_name: '',
        phone_number: '',
        another_phone: '',
        building_number: '',
        street: '',
        landmark: '',
        floor: '',
        home: '',
        address: '',
        delivery_fees: '',
        government_id: '',
        city_id: '',
      },
      { emitEvent: false }
    );
  }

  clearProduct(): void {
    localStorage.removeItem('cart');
    localStorage.removeItem('cartWarehouseId');
    this.clearcart = false;
    this.cartItems = [];
    this.cartHasProducts = false;
    this.cartHasServices = false;
    this.selectedProductsDetails = [];
    this.selectedServicesDetails = [];
  }

  buildSelectedProductsFromParams(): void {
    this.selectedProductsDetails = [];
    for (let i = 0; i < this.arrayofids.length; i++) {
      const id = +this.arrayofids[i]!;
      const name = this.arrayofitems[i];
      const qty = +this.arrayofqty[i]!;
      const price = +this.arrayofprices[i]!;
      const bounes = +this.arrayofbounes[i];
      const product = this.filteredProviders.find(p => p.id === id);
      if (product) {
        this.selectedProductsDetails.push({
          product,
          quantity: qty,
          price: price,
          bounes: bounes || null
        });
      } else {
        console.warn(`⛔ Skipping index ${i} due to missing product`, { id, name, qty, price });
      }
    }

    this.contentReady = false;
  }
  onitemchange(input: string): void {
    const match = input.match(/^(\d+)type(\d+)$/);
    if (match) {
      const [, id, type] = match;
      this.createOrderByid = id;
      this.createOrderByidType = type;
    } else {
      console.error('Input format is invalid.');
    }
  }

  generateQr(id: any, clientId: any, userId: any): void {
    const orderLink = `${window.location.origin}/Addorderclient?orderId=${id}&cart=${encodeURIComponent(JSON.stringify(this.arrayofids))}&client=${encodeURIComponent(clientId)}&prices=${encodeURIComponent(JSON.stringify(this.arrayofprices))}&page_id=${encodeURIComponent(userId)}`;
    console.log('Generated QR Link:', orderLink);
    this._orderService.generateLinkQr(orderLink, id).subscribe({
      next: (data) => console.log('QR Generated ✅:', data),
      error: (error) => console.error('QR Error ⛔:', error),
    });
  }
}
